import React, { Suspense, useContext, useEffect, useState } from 'react';
import Redis from 'ioredis';
import MobileDetect from 'mobile-detect';
import dynamic from 'next/dynamic';

import * as appContext from '../../../components/AppContext';
import Checkers from '../../../helpers/class/Checkers';
import * as DataFetchHelper from '../../../helpers/DataFetchHelper';
import * as MethodHelper from '../../../helpers/MethodHelper';

const Articles = dynamic( () => import( '../../../components/templates/articles' ), { suspense: true });
import { Fancybox } from '@fancyapps/ui/dist/fancybox.esm';
import fs from 'fs';

import { fetchCategoryData } from '../../../helpers/DataFetchHelper';
import { setPageId } from '../../../redux/actions';
import { wrapper } from '../../../redux/store';
import MainLayout from "../../../layouts/MainLayout";
import PropertyComponent from "../../../components/entities/property";
import {redis} from "../../../redis";

export default function Home ( props ) {

  const pageContext = useContext( appContext.page );
  pageContext.pageId = props.app_data.page_id;

  pageContext.isMobile = props.isMobile;
  pageContext.isTablet = props.isTablet;
  pageContext.isDesktop = props.isDesktop;

  pageContext.appSettings = props.app;

  const [ urlHref, setUrlHref ] = useState( null );
  React.useEffect( () => {
    if ( window !== undefined ) {
      setUrlHref( window.location.href + '/' );
    }
  }, [urlHref]);

  const domain = props.domain;
  const app_data = props.app_data;
  const app = props.app;
  const head = props.head;
  const footer = props.footer;

  const locations = props.locations;
  const navigation = props.navigation;
  const content = props.content;
  const rgbDesignColor = props.rgbDesignColor;
  const rgbSearchbarColor = props.rgbSearchbarColor;

  const isDesktop = props.isDesktop;
  const builder = Checkers.objChildExists( app, 'builder' ) ? app.builder : null;

  const image_fb_meta = Checkers.isValidArray( head.og_image ) ? head.og_image[0].image : null;

  const contactIcons = {
    phoneIcon: app.showPhoneIconOnMenu,
    chatIcon: app.showChatIconOnMenu,
    mailIcon: app.showMailIconOnMenu,
    phoneIconData: app.menuPhoneIconData,
    chatIconData: app.menuChatIconData,
    mailIconData: app.menuMailIconData
  }

  useEffect( () => {
    if ( window !== undefined ) {
      window.designMode = app.designMode;
    }
    Fancybox.bind( "[data-fancybox]", {
      Image: {
        zoom: false,
      },
    });
  });
  const captchaSiteKey = '6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY';

  return (
      <MainLayout {...props}>
        <Suspense>
          <Articles
            type={'category'}
            isArticle={false}
            isArticleCategory={true}
            isBlogArticle={false}
            domain={domain}
            app_data={app_data}
            app={app}
            head={head}
            footer={footer}
            locations={locations}
            navigation={navigation}
            content={content}
            rgbDesignColor={rgbDesignColor}
            rgbSearchbarColor={rgbSearchbarColor}
            isDesktop={isDesktop}
            image_fb_meta={image_fb_meta}
            contactIcons={contactIcons}
            urlHref={urlHref}
            builder={builder}
            htmlSections={props.html_sections}
          />
        </Suspense>
      </MainLayout>
  )
}

// export async function getServerSideProps ({ req, res }) {
export const getServerSideProps = wrapper.getServerSideProps( ( store ) => async (
  { req,
    res,
    query
  }) => {

  const [ isMobile, isTablet,  isDesktop ] = Checkers.getUserAgentData( store, req )

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=43200, stale-while-revalidate=60'
  )

  let subdomain = null;
  const slug_data = null;

  let head = null;
  let app = null;
  let page = null;
  let app_data = null;
  let navigation = null;
  let content = null;
  //const script_sections = null;
  let locations = null;
  let footer = null;
  let rgbSearchbarColor = null;
  let rgbDesignColor = null;
  //const amenities = null;
  const category_id = query.category_id;
  let html_sections;
  let contactHtml = null

  let manifest = null;

  const domain = req.headers.host;
  const hostname_parts = req.headers.host.split( '.' );
  const parts = hostname_parts.length;

  app_data = await DataFetchHelper.fetchAppData( req, redis, res );
  if ( app_data==false ) {
    return {
      notFound: true,
    }
  }

  store.dispatch( setPageId( app_data.page_id ) )

  if ( app_data != null ) {

    await DataFetchHelper.fetchSystemData( redis, app_data.page_id, store ).then( ( response ) => {
      head = response.head
      app = response.app
      page = response.page
      navigation = response.navigation
      locations = response.locations
      footer = response.footer
      html_sections = response.html_sections
      contactHtml = response.contactHtml
    })

    content = await DataFetchHelper.fetchCategoryData( redis, app_data.page_id, category_id )

    const siteContent = await DataFetchHelper.fetchContentData( redis, app_data.page_id )
    content.socialLinks = siteContent?.socialLinks ?? null
    content.managerContact = siteContent?.managerContact ?? null
    content.partnerLinks = siteContent?.partnerLinks ?? null
    content.propertyBadges = siteContent?.propertyBadges ?? null
    if ( siteContent?.details?.title != undefined ) {
      content.details = { ...content.details, title: siteContent.details.title }
    }
  }

  if ( Object.keys( head ).length > 0 ) {
    manifest = MethodHelper.initManifest( head, app, '../../?source=pwa' );
    manifest = MethodHelper.extendManifest( manifest, head );

    const json = JSON.stringify( manifest );
    const fs = require( 'fs' );
    fs.writeFile( './public/manifest.json', json, ( err ) => {
      if ( err ) {
        

        // eslint-disable-next-line no-console
        console.error( err )
        return
      }
    });
  }

  if ( app != null && app.searchbarBgColor != null )
    rgbSearchbarColor = MethodHelper.hexToRgb( app.searchbarBgColor );
  if ( app != null && app.designColor )
    rgbDesignColor = MethodHelper.hexToRgb( app.designColor );

  

  return {
    props: {
      app_data: app_data,
      head: head,
      page: page != null ? page.page : null,
      app: app,
      builder: app != null && app.builder != null ? app.builder : null,
      navigation: navigation,
      content: content,
      locations: locations,
      footer: footer,
      html_sections: html_sections,
      domain: domain,
      subdomain: subdomain,
      parts: parts,
      slug_data: slug_data,
      rgbDesignColor: rgbDesignColor,
      rgbSearchbarColor: rgbSearchbarColor,
      isDesktop: isDesktop,
      contactHtml: contactHtml
    }
  }
})
